import { useEffect } from 'react';

export const useLinkScroll = (id) => {
  useEffect(() => {
    const ele = document.querySelector(id);
    if (ele) {
      ele.addEventListener('click', () => {
        const targetId = ele.getAttribute('data-target');
        const targetElement = document.querySelector(`#${targetId}`);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }, [id]);
};
